import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Rooted in craft",
    body: "We begin with heritage textiles — Chantilly lace, handwoven cotton, silk georgette. Every metre is chosen by hand, nothing rushed.",
    span: "md:col-span-7",
    img: "https://images.unsplash.com/photo-1635631191834-f1dfe187ef85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwbW9kZWwlMjBlZGl0b3JpYWwlMjB3YXJtJTIwbGlnaHRpbmclMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc4NjM0NTQwNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "02",
    title: "Dyed in warm ground",
    body: "Blush, clay, terracotta and sand. Our palette is drawn from soil and low light — shades that flatter and never shout.",
    span: "md:col-span-5",
    img: null,
  },
  {
    n: "03",
    title: "Cut for celebration",
    body: "Small runs, generous drape, silhouettes that carry through weddings and festivals — and the quiet years that follow.",
    span: "md:col-span-5",
    img: null,
  },
  {
    n: "04",
    title: "Finished by hand",
    body: "Pearl scallops, farshi hems and lace trims are set by our karigars, then pressed and named before each piece reaches you.",
    span: "md:col-span-7",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_threads-shop-281/artifacts/elxwqyqe_IMG_3857.webp",
  },
];

const Chapter = ({ ch, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
    className={`${ch.span} relative border border-aak-border bg-aak-surface/50 overflow-hidden`}
  >
    {ch.img ? (
      <div className="grid grid-cols-1 sm:grid-cols-2 h-full">
        <div className="p-8 md:p-12 flex flex-col justify-between min-h-[280px]">
          <span className="font-serif text-6xl text-aak-primary/30 leading-none">{ch.n}</span>
          <div>
            <h3 className="font-serif text-3xl md:text-4xl text-aak-fg leading-none mb-4">{ch.title}</h3>
            <p className="text-sm text-aak-mutedfg leading-relaxed max-w-xs">{ch.body}</p>
          </div>
        </div>
        <div className="relative min-h-[240px] overflow-hidden">
          <img src={ch.img} alt={ch.title} className="w-full h-full object-cover" />
        </div>
      </div>
    ) : (
      <div className="p-8 md:p-12 flex flex-col justify-between min-h-[280px] relative">
        <span className="absolute -bottom-6 right-2 font-serif text-[9rem] text-aak-primary/10 leading-none pointer-events-none select-none">
          {ch.n}
        </span>
        <span className="font-serif text-6xl text-aak-primary/40 leading-none relative z-10">{ch.n}</span>
        <div className="relative z-10">
          <h3 className="font-serif text-3xl md:text-4xl text-aak-fg leading-none mb-4">{ch.title}</h3>
          <p className="text-sm text-aak-mutedfg leading-relaxed max-w-xs">{ch.body}</p>
        </div>
      </div>
    )}
  </motion.div>
);

export const Manifesto = () => (
  <section id="manifesto" className="py-24 md:py-32 px-6 md:px-12 max-w-[1600px] mx-auto scroll-mt-24">
    <div className="mb-16 md:mb-24 max-w-3xl">
      <p className="text-xs uppercase tracking-[0.3em] text-aak-primary mb-6">The Atelier</p>
      <h2 className="font-serif font-light text-5xl md:text-7xl tracking-tighter leading-[0.95] text-aak-fg">
        A house built on
        <span className="italic text-aak-primary"> patience</span>, material and light.
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
      {chapters.map((ch, i) => (
        <Chapter key={ch.n} ch={ch} i={i} />
      ))}
    </div>
  </section>
);
